/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CompanyType {
    LIMITED_PARTNERSHIP = 'limited_partnership',
    LIMITED_LIABILITY_PARTNERSHIP = 'limited_liability_partnership',
    LIMITED_LIABILITY_COMPANY = 'limited_liability_company',
    CORPORATION = 'corporation',
    COOPERATIVE = 'cooperative',
    OTHER = 'other',
}
